import React, { useEffect, useState, useContext, useCallback } from "react";
import { Images } from 'constants'
import { CommonModal } from "components/common";
import { UserContext } from "context";
import { StorageServices } from "utils";
import { GoSignOut } from "react-icons/go";
import StorageService from "utils/StorageServices/StorageServices";
import { getDashbordData } from "_services";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "features";
import { utils } from "helper";
import { UpgradeBar } from "..";
import { AddCompanyFirmModal, CompanyCanvas } from "modals";
import { FaChevronDown } from "react-icons/fa6";
import './navbar.css';
import { useSelector } from "react-redux";

const Navbar = () => {

  const TRANSPORT_MODE = process.env.REACT_APP_TRANSPORT_MODE;
  const firmUI = TRANSPORT_MODE !== "production" ? true : true;

  // Context and hooks
  const {
    isSidebar,
    setToggleSidebar,
    setToken,
    userData,
    setUserData,
    setWarningDetails,
    showUpdateBtn,
    warningDetails,
    setShowWarnning,
    setNoAccessISOpen
  } = useContext(UserContext);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const company_id = StorageServices.getCompanyId();
  const firm_id = StorageServices.getFirmId()

  // State management
  const [show, setShow] = useState(false);
  const [companyName, setCompanyName] = useState({});
  const [isProfileModal, setIsProfileModal] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isOpenFirm, setIsOpenFirm] = useState(false);
  const [firmName, setFirmName] = useState({})

  const { loading, error, data } = useSelector((state) => state.auth);

  // Memoized calculations
  const remainingDays = utils?.calculateRemainingDays(warningDetails?.web_end_date) || "";
  const noWebAccess = !warningDetails?.subscription_data?.web_access;


  const containerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "16px",
    fontWeight: "500",
    color: "#0d47a1",

  };

  const iconStyle = {
    fontSize: "14px",
    color: "#040505ff",
    width: "24px"
  };

  const balanceStyle = {
    marginLeft: "4px",
    fontWeight: "600",
    color: "#000",
  };

  const buttonStyle = {
    marginLeft: "16px",
    padding: "6px 14px",
    fontSize: "14px",
    fontWeight: "500",
    borderRadius: "6px",
    border: "2px solid #1976d2",
    backgroundColor: "#fff",
    color: "#1976d2",
    cursor: "pointer",
  };

  // Handle company name selection
  const handleCompanyName = useCallback((id) => {
    const selectedCompany = userData?.user_detail?.company_list?.find(
      (item) => item?.company_id?._id === id
    )?.company_id;
    setCompanyName(selectedCompany || {});

  }, [userData]);

  const handleFirmName = (id) => {
    const selectedCompany = userData?.user_detail?.firm_list?.find(
      (item) => item?.firm_id?._id === id
    )?.firm_id;

    setFirmName(selectedCompany || {});
  };

  // Set initial company name
  useEffect(() => {
    if (!userData?.user_detail?.company_list?.length) return;

    const currentCompany = userData?.user_detail?.company_list?.find(
      (item) => item?.company_id?._id === company_id
    )?.company_id;

    const currentFirm = userData?.user_detail?.firm_list?.find(
      (item) => item?.firm_id?._id === userData?.user_detail?.select_firm_id
    )?.firm_id;

    const defaultCompany = currentCompany?.company
      ? currentCompany
      : userData?.user_detail?.company_list[0]?.company_id;


    const defaultFirm = (() => {
      if (currentFirm?.firm) {
        return currentFirm;
      }

      const userDetail = userData?.user_detail;
      const hasSingleFirm = userDetail?.firm_list?.length === 1;

      if (hasSingleFirm) {
        return userDetail?.firm_list[0]?.firm_id;
      }

      return { firm: "All Firm", _id: "" };
    })();

    setCompanyName(defaultCompany || {});
    setFirmName(defaultFirm || {})
    company_id && StorageService.setFirmId(defaultFirm?._id ? defaultFirm?._id : "")
  }, [userData, company_id]);

  // Fetch dashboard data when company modal opens
  useEffect(() => {
    if (show && company_id) {
      getAllDashboardData(company_id);
    }
  }, [show, company_id]);

  useEffect(() => {
    if (isOpenFirm && company_id && firmUI) {
      getAllDashboardData(company_id, firm_id);
    }
  }, [firm_id, isOpenFirm]);

  // Handle clicks outside dropdown
  const handleClickOutside = useCallback((event) => {
    if (!event.target.closest('.dropdown')) {
      setDropdownVisible(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [handleClickOutside]);

  // API calls
  const getAllDashboardData = async (companyId, firm_id = "") => {
    const postData = {
      company_id: companyId,
      select_company_id: 1,
      firm_id: StorageService.getFirmId() || firm_id
    };

    try {
      const response = await getDashbordData(postData);
      if (response?.responseCode === 200) {
        StorageService.setLocalItem("userData", JSON.stringify(response.data));
        setUserData(response.data);
      } else {
        toast.error(response?.responseMessage || "Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      toast.error("Failed to fetch dashboard data");
    }
  };

  // Sign out handler
  const signOut = async () => {
    try {
      const token = StorageService.getToken();
      if (!token) {
        toast.error("No valid session found");
        return;
      }

      setIsLoading(true);
      const res = await dispatch(logout({ token }));

      if (res.payload?.responseCode === 200) {
        setWarningDetails("");
        await StorageServices.clearStorage();
        setToken(null);
        toast.success(res.payload?.responseMessage || "Logged out successfully");
        // window.location.href = "/";
      } else {
        toast.error(res.payload?.responseMessage || "Logout failed");
      }
    } catch (error) {
      console.error("Logout error:", error);
      toast.error("Logout failed");
    } finally {
      setIsLoading(false);
    }
  };

  // Event handlers
  const toggleDropdown = useCallback(() => {
    setDropdownVisible(prev => !prev);
  }, []);

  const handleProfileClick = useCallback((e) => {
    e.preventDefault();
    setIsProfileModal(prev => !prev);
  }, []);

  const handleNavigationClick = useCallback((path) => (e) => {
    if (remainingDays === 0) {
      e.preventDefault();
      setShowWarnning(true);
      return;
    }

    if (noWebAccess) {
      e.preventDefault();
      setNoAccessISOpen(true)
      return;
    }
    navigate(path);
  }, [remainingDays, navigate, setShowWarnning]);

  const closeLogoutModal = useCallback(() => setIsLogout(false), []);
  const openLogoutModal = useCallback(() => setIsLogout(true), []);
  const closeDropdown = useCallback(() => setDropdownVisible(false), []);
  const openCompanyModal = useCallback(() => setShow(true), []);
  const closeCompanyModal = useCallback(() => setShow(false), []);

  // Modal props
  const logoutModalProps = {
    isOpen: isLogout,
    closeModal: closeLogoutModal,
    modalTitle: "Logout",
    submitTitle: "Logout",
    cancelTitle: "Close",
    onSubmit: signOut,
    isLoadding: loading,
  };

  // User avatar source
  const userAvatarSrc = userData?.user_detail?.avatar
    ? `${userData.user_detail.s3_url}${userData.user_detail.avatar}`
    : Images.LOGUSER.default;

  let firmAndCompanyProps = {
    isOpen: isOpenFirm,
    closeModal: (e) => setIsOpenFirm(false),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal  _firmAndCompModal",
    modalTitle: "Select Firm",
    submitTitle: "Add Company",
    handleCompanyName: () => handleCompanyName(),
    handleFirmName
  };

  const getLogoText = (name) => {
    if (!name) return "";

    const words = name.trim().split(" ");

    // if only 1 word → return first 2 letters
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }

    // if multiple words → return first letter of first two words
    return (words[0][0] + words[1][0]).toUpperCase();
  };

  return (
    <>
      <header className="stickyHeader">
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {firmUI && <>
            <button
              className="_hamToggle"
              onClick={() => setToggleSidebar(!isSidebar)}
              aria-label="Toggle sidebar"
            >
              <img src={Images.HAMBERGER.default} alt="Menu" />
            </button>

            <div className="__frmAndComp_mainBx" onClick={setIsOpenFirm}>
              <div className="__fco_logo"> {getLogoText(companyName?.company)}</div>

              <div className="__frmCo_detail">
                <span>{companyName?.company}</span>
                <div className="__frmCo_firm">{firmName?.firm} <FaChevronDown /></div>
              </div>
            </div>
          </>}


        </div>

        {showUpdateBtn && (
          <UpgradeBar
            remainingDays={remainingDays}
            warningDetails={warningDetails}
          />
        )}

        <div className="_rSide_navLs">
          <div className="_rsl_fx" style={{ display: "flex", gap: "10px", marginRight: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={handleNavigationClick("/wallet")}>
              <div style={containerStyle}>
                <img src={Images.WALLET_NAV.default} alt="" style={iconStyle} />
                <span style={{ color: "#001B50", fontSize: "14px", fontWeight: 500 }}>Wallet Balance</span>
                <span style={{ color: "#000", fontSize: "14px", fontWeight: 500 }}>₹ 0</span>
              </div>

            </div>
          </div>

          <div className="_rsl_fx" >
            {/* <a
              className="_compList_modBtn"
              aria-label="Select company"
              onClick={openCompanyModal}
            >
              <span>{companyName?.company || "Select Company"}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="6"
                viewBox="0 0 8 6"
                fill="none"
              >
                <path
                  opacity="0.8"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.33371 5.3195C4.22354 5.42964 4.07412 5.49152 3.91833 5.49152C3.76254 5.49152 3.61313 5.42964 3.50295 5.3195L0.179328 1.99587C0.123214 1.94167 0.0784545 1.87684 0.0476627 1.80516C0.0168714 1.73348 0.000664205 1.65639 -1.38542e-05 1.57838C-0.000691436 1.50037 0.0141735 1.423 0.043715 1.3508C0.073256 1.27859 0.116882 1.21299 0.172047 1.15783C0.227211 1.10267 0.292809 1.05904 0.365013 1.0295C0.437218 0.999958 0.514583 0.985092 0.592594 0.98577C0.670605 0.986448 0.7477 1.00266 0.81938 1.03345C0.891061 1.06424 0.955891 1.109 1.01009 1.16511L3.91833 4.07336L6.82658 1.16511C6.93739 1.05809 7.0858 0.998871 7.23985 1.00021C7.39389 1.00155 7.54125 1.06334 7.65018 1.17227C7.75912 1.2812 7.8209 1.42856 7.82224 1.58261C7.82358 1.73665 7.76436 1.88506 7.65734 1.99587L4.33371 5.3195Z"
                  fill="black"
                />
              </svg>
            </a> */}

            <div className="_vertDivider"></div>

            <div className="_notifyBx">
              <a aria-label="Notifications">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M15.8398 11.3281V8.33984C15.8398 7.66276 15.7292 7.02474 15.5078 6.42578C15.2995 5.8138 15.0033 5.26367 14.6191 4.77539C14.235 4.28711 13.7826 3.86068 13.2617 3.49609C12.7409 3.14453 12.168 2.88411 11.543 2.71484C11.4258 2.40234 11.2272 2.14844 10.9473 1.95312C10.6673 1.75781 10.3516 1.66016 10 1.66016C9.64844 1.66016 9.33268 1.75781 9.05273 1.95312C8.77279 2.14844 8.57422 2.40234 8.45703 2.71484C7.83203 2.88411 7.25911 3.14453 6.73828 3.49609C6.21745 3.86068 5.76497 4.28711 5.38086 4.77539C4.99674 5.26367 4.70052 5.8138 4.49219 6.42578C4.27083 7.02474 4.16016 7.66276 4.16016 8.33984V11.3281L2.75391 12.7539C2.67578 12.819 2.61393 12.9036 2.56836 13.0078C2.52279 13.112 2.5 13.2227 2.5 13.3398V15C2.5 15.2344 2.58138 15.4329 2.74414 15.5957C2.9069 15.7585 3.10547 15.8398 3.33984 15.8398H16.6602C16.8945 15.8398 17.0931 15.7585 17.2559 15.5957C17.4186 15.4329 17.5 15.2344 17.5 15V13.3398C17.5 13.2227 17.4772 13.112 17.4316 13.0078C17.3861 12.9036 17.3307 12.819 17.2656 12.7539L15.8398 11.3281ZM15.8398 14.1602H4.16016V13.6719L5.58594 12.2461C5.66406 12.181 5.72591 12.0964 5.77148 11.9922C5.81706 11.888 5.83984 11.7773 5.83984 11.6602V8.33984C5.83984 7.76693 5.94401 7.22656 6.15234 6.71875C6.3737 6.21094 6.67318 5.76823 7.05078 5.39062C7.42839 5.01302 7.87109 4.71354 8.37891 4.49219C8.88672 4.27083 9.42708 4.16016 10 4.16016C10.5729 4.16016 11.1133 4.27083 11.6211 4.49219C12.1289 4.71354 12.5716 5.01302 12.9492 5.39062C13.3268 5.76823 13.6263 6.21094 13.8477 6.71875C14.056 7.22656 14.1602 7.76693 14.1602 8.33984V11.6602C14.1602 11.7773 14.1829 11.888 14.2285 11.9922C14.2741 12.0964 14.3359 12.181 14.4141 12.2461L15.8398 13.6719V14.1602ZM10 18.3398C10.5469 18.3398 11.0319 18.1836 11.4551 17.8711C11.8783 17.5586 12.1745 17.1615 12.3438 16.6797V16.6602H7.65625C7.82552 17.1549 8.12174 17.5586 8.54492 17.8711C8.9681 18.1836 9.45312 18.3398 10 18.3398Z"
                    fill="#536485"
                  />
                </svg>
              </a>
              <span>5</span>
            </div>

            <div className="_helpDsk">
              <Link to="/support" aria-label="Support">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M9 0C13.9707 0 18 4.0293 18 9C18 13.9707 13.9707 18 9 18C7.5636 18.002 6.14774 17.6587 4.87171 16.9992L1.42831 17.9595C1.23619 18.0131 1.03328 18.0147 0.840359 17.9641C0.647436 17.9134 0.471441 17.8124 0.330406 17.6714C0.189371 17.5304 0.0883664 17.3544 0.0377419 17.1614C-0.0128825 16.9685 -0.0113068 16.7656 0.0423075 16.5735L1.00351 13.1328C0.342324 11.8556 -0.00186192 10.4381 7.57525e-06 9C7.57525e-06 4.0293 4.02931 0 9 0ZM9 1.35C6.9711 1.35 5.02529 2.15598 3.59064 3.59063C2.15599 5.02528 1.35001 6.97109 1.35001 9C1.35001 10.323 1.68571 11.5947 2.31571 12.7233L2.45071 12.9663L1.44991 16.5519L5.03821 15.5511L5.28121 15.6861C6.30215 16.2537 7.43953 16.58 8.60612 16.6399C9.77271 16.6998 10.9375 16.4918 12.0113 16.0318C13.085 15.5717 14.0391 14.8719 14.8005 13.986C15.5618 13.1001 16.1101 12.0515 16.4035 10.9208C16.6968 9.79013 16.7272 8.60728 16.4925 7.46297C16.2578 6.31866 15.7642 5.2433 15.0495 4.31934C14.3348 3.39538 13.4179 2.64737 12.3693 2.13266C11.3207 1.61795 10.1681 1.35022 9 1.35ZM9 12.15C9.2387 12.15 9.46762 12.2448 9.6364 12.4136C9.80518 12.5824 9.9 12.8113 9.9 13.05C9.9 13.2887 9.80518 13.5176 9.6364 13.6864C9.46762 13.8552 9.2387 13.95 9 13.95C8.76131 13.95 8.53239 13.8552 8.36361 13.6864C8.19483 13.5176 8.10001 13.2887 8.10001 13.05C8.10001 12.8113 8.19483 12.5824 8.36361 12.4136C8.53239 12.2448 8.76131 12.15 9 12.15ZM9 4.275C9.65641 4.275 10.2859 4.53576 10.7501 4.99991C11.2142 5.46406 11.475 6.09359 11.475 6.75C11.475 7.659 11.2077 8.1666 10.5291 8.8731L10.377 9.027C9.8172 9.5868 9.675 9.8244 9.675 10.35C9.675 10.529 9.60389 10.7007 9.4773 10.8273C9.35071 10.9539 9.17903 11.025 9 11.025C8.82098 11.025 8.64929 10.9539 8.52271 10.8273C8.39612 10.7007 8.325 10.529 8.325 10.35C8.325 9.441 8.5923 8.9334 9.2709 8.2269L9.423 8.073C9.9828 7.5132 10.125 7.2756 10.125 6.75C10.1241 6.46225 10.0129 6.18579 9.81439 5.97749C9.61587 5.76918 9.34507 5.64487 9.0577 5.63011C8.77032 5.61536 8.48822 5.71128 8.2694 5.89816C8.05059 6.08504 7.9117 6.34865 7.8813 6.6348L7.875 6.75C7.875 6.92902 7.80389 7.10071 7.6773 7.22729C7.55071 7.35388 7.37903 7.425 7.20001 7.425C7.02098 7.425 6.8493 7.35388 6.72271 7.22729C6.59612 7.10071 6.52501 6.92902 6.52501 6.75C6.52501 6.09359 6.78576 5.46406 7.24992 4.99991C7.71407 4.53576 8.34359 4.275 9 4.275Z"
                    fill="#536485"
                  />
                </svg>
              </Link>
            </div>

            <div className="_settingBx">
              <a aria-label="Settings" onClick={() => navigate("/setting/user")}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="18"
                  viewBox="0 0 17 18"
                  fill="none"
                >
                  <path
                    d="M16.4267 11.0267L15.1412 9.92764C15.202 9.55475 15.2334 9.17401 15.2334 8.79327C15.2334 8.41253 15.202 8.0318 15.1412 7.65891L16.4267 6.55987C16.5236 6.47687 16.593 6.36632 16.6256 6.24292C16.6582 6.11952 16.6525 5.98911 16.6092 5.86905L16.5915 5.81802C16.2377 4.82894 15.7077 3.91204 15.0274 3.11165L14.992 3.07043C14.9095 2.97339 14.7995 2.90363 14.6765 2.87034C14.5536 2.83706 14.4234 2.84182 14.3032 2.88399L12.7076 3.45117C12.1188 2.96838 11.4614 2.58764 10.7509 2.32073L10.4428 0.652553C10.4196 0.527032 10.3587 0.411555 10.2682 0.321464C10.1778 0.231373 10.0621 0.170933 9.93647 0.148174L9.88348 0.138361C8.86099 -0.0461203 7.7855 -0.0461203 6.763 0.138361L6.71001 0.148174C6.5844 0.170933 6.46869 0.231373 6.37825 0.321464C6.28781 0.411555 6.22692 0.527032 6.20367 0.652553L5.89359 2.32858C5.18881 2.59556 4.53249 2.9761 3.95065 3.4551L2.34331 2.88399C2.22313 2.84148 2.09287 2.83656 1.96982 2.86986C1.84678 2.90316 1.73678 2.97312 1.65445 3.07043L1.61912 3.11165C0.939568 3.91261 0.409733 4.82935 0.0549558 5.81802L0.0372927 5.86905C-0.0510227 6.11437 0.0215922 6.38913 0.219811 6.55987L1.52099 7.67069C1.46015 8.03965 1.43071 8.41646 1.43071 8.79131C1.43071 9.16812 1.46015 9.54494 1.52099 9.91193L0.219811 11.0227C0.122852 11.1058 0.0534573 11.2163 0.0208542 11.3397C-0.0117488 11.4631 -0.00601527 11.5935 0.0372927 11.7136L0.0549558 11.7646C0.41018 12.7537 0.936148 13.6663 1.61912 14.471L1.65445 14.5122C1.73698 14.6092 1.84698 14.679 1.96995 14.7123C2.09292 14.7456 2.22309 14.7408 2.34331 14.6986L3.95065 14.1275C4.53549 14.6084 5.18903 14.9891 5.89359 15.254L6.20367 16.9301C6.22692 17.0556 6.28781 17.1711 6.37825 17.2612C6.46869 17.3512 6.5844 17.4117 6.71001 17.4344L6.763 17.4443C7.79489 17.6297 8.85159 17.6297 9.88348 17.4443L9.93647 17.4344C10.0621 17.4117 10.1778 17.3512 10.2682 17.2612C10.3587 17.1711 10.4196 17.0556 10.4428 16.9301L10.7509 15.2619C11.4611 14.9957 12.1223 14.6137 12.7076 14.1315L14.3032 14.6986C14.4234 14.7411 14.5536 14.7461 14.6767 14.7128C14.7997 14.6795 14.9097 14.6095 14.992 14.5122L15.0274 14.471C15.7103 13.6644 16.2363 12.7537 16.5915 11.7646L16.6092 11.7136C16.6975 11.4722 16.6249 11.1974 16.4267 11.0267ZM13.7478 7.89049C13.7968 8.18684 13.8223 8.49104 13.8223 8.79524C13.8223 9.09943 13.7968 9.40363 13.7478 9.69998L13.6182 10.487L15.0843 11.741C14.862 12.2531 14.5815 12.7377 14.2482 13.1855L12.427 12.5398L11.8107 13.0462C11.3417 13.4308 10.8196 13.7331 10.2544 13.945L9.50667 14.2257L9.15537 16.1293C8.60108 16.1921 8.04148 16.1921 7.48719 16.1293L7.13589 14.2217L6.39404 13.9372C5.83471 13.7252 5.31463 13.423 4.8495 13.0403L4.23326 12.532L2.40022 13.1835C2.06659 12.7341 1.7879 12.2494 1.56417 11.7391L3.04591 10.4732L2.91834 9.6882C2.87124 9.39578 2.84572 9.09354 2.84572 8.79524C2.84572 8.49496 2.86927 8.19469 2.91834 7.90227L3.04591 7.11724L1.56417 5.85139C1.78594 5.33916 2.06659 4.85637 2.40022 4.40694L4.23326 5.05851L4.8495 4.55021C5.31463 4.16751 5.83471 3.86527 6.39404 3.65331L7.13785 3.37267L7.48915 1.46505C8.04063 1.40225 8.60389 1.40225 9.15733 1.46505L9.50863 3.36874L10.2564 3.64939C10.8196 3.86135 11.3436 4.16358 11.8127 4.54824L12.4289 5.05459L14.2502 4.4089C14.5838 4.85833 14.8625 5.34308 15.0862 5.85335L13.6202 7.10743L13.7478 7.89049ZM8.3252 5.14486C6.41759 5.14486 4.87109 6.69137 4.87109 8.59898C4.87109 10.5066 6.41759 12.0531 8.3252 12.0531C10.2328 12.0531 11.7793 10.5066 11.7793 8.59898C11.7793 6.69137 10.2328 5.14486 8.3252 5.14486ZM9.87956 10.1533C9.67569 10.3578 9.43341 10.5199 9.16665 10.6304C8.8999 10.7409 8.61393 10.7975 8.3252 10.7971C7.7384 10.7971 7.18692 10.5674 6.77085 10.1533C6.5664 9.94946 6.40427 9.70718 6.2938 9.44043C6.18332 9.17367 6.12668 8.8877 6.12713 8.59898C6.12713 8.01217 6.35675 7.46069 6.77085 7.04463C7.18692 6.62856 7.7384 6.40091 8.3252 6.40091C8.91201 6.40091 9.46349 6.62856 9.87956 7.04463C10.084 7.24849 10.2461 7.49078 10.3566 7.75753C10.4671 8.02429 10.5237 8.31025 10.5233 8.59898C10.5233 9.18579 10.2937 9.73727 9.87956 10.1533Z"
                    fill="#536485"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div className="_userLd_btn">
            <div className="dropdown">
              <button
                onClick={toggleDropdown}
                className="_logIn_user"
                aria-label="User menu"
                aria-expanded={dropdownVisible}
              >
                <img src={userAvatarSrc} alt="User avatar" />
              </button>

              {dropdownVisible && (
                <div className='dropdown-menu show menuAnimate'>
                  <div className="_usrDetail_bx">
                    <div className="_usrDetail_head">
                      <img src={userAvatarSrc} alt="User avatar" />
                      <div className="_usrDetail_ins">
                        <h4>{userData?.user_detail?.full_name || "User"}</h4>
                        <p>{userData?.mobile_no || "N/A"}</p>
                      </div>

                      <button
                        className="_closeDrop"
                        onClick={closeDropdown}
                        aria-label="Close dropdown"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 10 10"
                          fill="none"
                        >
                          <path
                            d="M8.98062 0.210388C8.91617 0.145811 8.83962 0.0945774 8.75535 0.0596208C8.67108 0.0246643 8.58075 0.00667089 8.48951 0.00667089C8.39828 0.00667089 8.30794 0.0246643 8.22367 0.0596208C8.1394 0.0945774 8.06285 0.145811 7.99841 0.210388L4.59202 3.60981L1.18563 0.203422C1.12114 0.138929 1.04458 0.0877708 0.960312 0.0528676C0.876048 0.0179643 0.785734 6.79542e-10 0.694528 0C0.603321 -6.79543e-10 0.513007 0.0179643 0.428743 0.0528676C0.344479 0.0877708 0.267915 0.138929 0.203422 0.203422C0.138929 0.267915 0.0877708 0.344479 0.0528676 0.428743C0.0179643 0.513007 -6.79542e-10 0.603321 0 0.694528C6.79543e-10 0.785734 0.0179643 0.876048 0.0528676 0.960312C0.0877708 1.04458 0.138929 1.12114 0.203422 1.18563L3.60981 4.59202L0.203422 7.99841C0.138929 8.0629 0.0877708 8.13947 0.0528676 8.22373C0.0179643 8.30799 0 8.39831 0 8.48951C0 8.58072 0.0179643 8.67103 0.0528676 8.7553C0.0877708 8.83956 0.138929 8.91613 0.203422 8.98062C0.267915 9.04511 0.344479 9.09627 0.428743 9.13117C0.513007 9.16608 0.603321 9.18404 0.694528 9.18404C0.785734 9.18404 0.876048 9.16608 0.960312 9.13117C1.04458 9.09627 1.12114 9.04511 1.18563 8.98062L4.59202 5.57423L7.99841 8.98062C8.0629 9.04511 8.13947 9.09627 8.22373 9.13117C8.30799 9.16608 8.39831 9.18404 8.48951 9.18404C8.58072 9.18404 8.67103 9.16608 8.7553 9.13117C8.83956 9.09627 8.91613 9.04511 8.98062 8.98062C9.04511 8.91613 9.09627 8.83956 9.13117 8.7553C9.16608 8.67103 9.18404 8.58072 9.18404 8.48951C9.18404 8.39831 9.16608 8.30799 9.13117 8.22373C9.09627 8.13947 9.04511 8.0629 8.98062 7.99841L5.57423 4.59202L8.98062 1.18563C9.24533 0.920923 9.24533 0.475097 8.98062 0.210388Z"
                            fill=""
                          />
                        </svg>
                      </button>
                    </div>

                    <div className="_usrDetail_btm">
                      <button className="_usrCh_btn" onClick={handleProfileClick}>
                        {/* Change Password */}
                      </button>
                      <button className="_usrClose_btn" onClick={openLogoutModal}>
                        <GoSignOut />
                        <span>Sign Out</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {show && (
        <CompanyCanvas
          handleCompanyName={handleCompanyName}
          setOpen={closeCompanyModal}
          open={show}
        />
      )}

      {isLogout && (
        <CommonModal {...logoutModalProps}>
          <p className="p-3">Are you sure you want to logout?</p>
        </CommonModal>
      )}

      {isOpenFirm && <AddCompanyFirmModal {...firmAndCompanyProps} />}
    </>
  );
};

export default Navbar;